import { Icon } from '@manychat/icons'

import { FlowChartIcon } from 'common/builder/components/chart/FlowChart/types/FlowChartIcon'

export class FlowChartIconBuilder {
  private icon: Icon
  private size: number
  private color?: string

  constructor(icon: Icon, size: number) {
    this.icon = icon
    this.size = size
  }

  public withColor(color: string): FlowChartIconBuilder {
    this.color = color
    return this
  }

  public build(): FlowChartIcon {
    return {
      icon: this.icon,
      size: this.size,
      color: this.color,
    }
  }
}
